/**
 * Бутафорская лента для /ux. Цифры выдуманы, чтобы крутить экран, а не ставить.
 * В кассу по этим числам ходить нельзя — ссылок на площадки здесь нет.
 */

export interface UxLeg {
  source: string;
  name: string;
  pick: string;
  odds: string;
  /** Что человек вводит в форму площадки. */
  enter: string;
  /** Подпись единицы ввода: ₽, шер, $. */
  enterUnit: string;
  /** Сколько спишут, если единица ввода — не рубли. Пусто — не показываем. */
  cost?: string;
  /** Цена шара в центах — только биржа. */
  cents?: string;
}

export interface UxFork {
  id: string;
  sport: string;
  market: string;
  match: string;
  line: 'live' | 'prematch';
  ageSec: number;
  profit: number;
  roiPct: number;
  staked: number;
  kind: 'crypto-book' | 'crypto-crypto' | 'ru-crypto' | 'ru-ru';
  kindLabel: string;
  legs: [UxLeg, UxLeg];
}

export const UX_FORKS: UxFork[] = [
  {
    id: 'ux-spirit',
    sport: 'CS2',
    market: 'карта 1 · победа',
    match: 'Spirit — Falcons',
    line: 'live',
    ageSec: 8,
    profit: 412,
    roiPct: 4.12,
    staked: 10000,
    kind: 'ru-crypto',
    kindLabel: 'крипто × ру',
    legs: [
      {
        source: 'thunderpick',
        name: 'Thunderpick',
        pick: '1-я карта — Spirit',
        odds: '2.10',
        enter: '4762',
        enterUnit: '₽',
      },
      {
        source: 'fonbet',
        name: 'Фонбет',
        pick: '1-я карта — Falcons',
        odds: '2.05',
        enter: '5238',
        enterUnit: '₽',
      },
    ],
  },
  {
    id: 'ux-kits',
    sport: 'CS2',
    market: 'матч · победа',
    match: 'Kits Esports — MOUZ NXT',
    line: 'live',
    ageSec: 12,
    profit: 380,
    roiPct: 3.8,
    staked: 10000,
    kind: 'crypto-book',
    kindLabel: 'биржа × контора',
    legs: [
      {
        source: 'polymarket',
        name: 'Polymarket',
        pick: 'победа Kits Esports',
        odds: '2.380',
        enter: '144.4',
        enterUnit: 'шер',
        cents: '42',
        cost: 'спишут 60.65 $ ≈ 4 920 ₽',
      },
      {
        source: 'pinnacle',
        name: 'Pinnacle',
        pick: 'победа MOUZ NXT',
        odds: '2.240',
        enter: '5079',
        enterUnit: '₽',
      },
    ],
  },
  {
    id: 'ux-roll',
    sport: 'футбол',
    market: 'тайм 1 · тотал больше 0.5',
    match: 'Brentford — Fulham',
    line: 'live',
    ageSec: 5,
    profit: 268,
    roiPct: 2.68,
    staked: 10000,
    kind: 'crypto-crypto',
    kindLabel: 'крипто × крипто',
    legs: [
      {
        source: 'rollbit',
        name: 'Rollbit',
        pick: 'тотал голов больше 0.5',
        odds: '1.72',
        enter: '5814',
        enterUnit: '₽',
      },
      {
        source: 'rainbet',
        name: 'Rainbet',
        pick: 'тотал голов меньше 0.5',
        odds: '2.38',
        enter: '4186',
        enterUnit: '₽',
      },
    ],
  },
  {
    id: 'ux-ruru',
    sport: 'теннис',
    market: 'сет 2 · победа',
    match: 'Медведев — Рублёв',
    line: 'live',
    ageSec: 19,
    profit: 540,
    roiPct: 5.4,
    staked: 10000,
    kind: 'ru-ru',
    kindLabel: 'две российские',
    legs: [
      {
        source: 'fonbet',
        name: 'Фонбет',
        pick: '2-й сет — Медведев',
        odds: '1.92',
        enter: '5208',
        enterUnit: '₽',
      },
      {
        source: 'winline',
        name: 'Winline',
        pick: '2-й сет — Рублёв',
        odds: '2.08',
        enter: '4792',
        enterUnit: '₽',
      },
    ],
  },
  {
    id: 'ux-pre',
    sport: 'Valorant',
    market: 'матч · победа',
    match: 'NAVI — G2',
    line: 'prematch',
    ageSec: 41,
    profit: 195,
    roiPct: 1.95,
    staked: 10000,
    kind: 'ru-crypto',
    kindLabel: 'крипто × ру',
    legs: [
      {
        source: 'ggbet',
        name: 'GGBet',
        pick: 'победа NAVI',
        odds: '1.87',
        enter: '5348',
        enterUnit: '₽',
      },
      {
        source: 'leon',
        name: 'Леон',
        pick: 'победа G2',
        odds: '2.18',
        enter: '4652',
        enterUnit: '₽',
      },
    ],
  },
];
